import { Link } from "react-scroll";
import "./home.scss";
import GitHub from "../../img/GitHub.png";
import Instagram from "../../img/Instagram.png";
import LinkedIn from "../../img/LinkedIn.png";

function Home() {
  return (
    <section className="main-container" id="home">
      <div className="container" id="container-home">
        <div className="social-container">
          <div className="social-button">
            <a href="https://www.linkedin.com/in/soham-mandaliya/" target="_SM">
              <img src={LinkedIn} />
            </a>
          </div>
          <div className="social-button">
            <a href="https://github.com/SohamM2003" target="_SM">
              <img src={GitHub} />
            </a>
          </div>
          <div className="social-button">
            <a href="https://www.instagram.com/soham___2003/" target="_SM">
              <img src={Instagram} />
            </a>
          </div>
        </div>
        <div className="intro-container">
          <div className="intro-heading">Hey, I'm Soham Mandaliya</div>
          <div className="intro-info">
            Full Stack Web Developer creating seamless digital experiences with
            expertise in both front-end and back-end technologies
          </div>
          <div className="intro-button">
            <Link className="btn" to="projects" smooth={true}>
              My Projects
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
